import React from "react";
export const BOSSVALETMENU = [
    {
        title: "Inicio",
        icon: <i className="pe-7s-home pe-lg"></i>,
        type: "link",
        path: `${process.env.REACT_APP_PUBLIC_URL}/dashboard/valet/default`,
        active: true,
        bookmark: false
    },
    {
        title: "Acciones",
        icon: <i className="pe-7s-network pe-lg"></i>,
        type: "link",
        path: `${process.env.REACT_APP_PUBLIC_URL}/dashboard/valet/default`,
        children: [
            { title: "Clientes", type: "sub" },
            {
                title: "Crear cliente",
                type: "link",
                path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valetuser`,
            },
            { title: "Valet", type: "sub" },
            {
                title: "Recoger vehiculo",
                type: "link",
                path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valetprocess`,
            },
            {
                title: "Procesos Activos",
                type: "link",
                path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valet/activeprocesses`,
            },
            {
                title: "Notificaciones",
                type: "link",
                path: `${process.env.REACT_APP_PUBLIC_URL}/pages/notifications`,
            },
            { title: "Reportes", type: "sub" },
        ]
    },

]
